const REMOTE_FLAG_BASE_URL = 'https://mainadmin.mautvignettedashboard.com/seeders/flags';

function isExternalUrl(value) {
    return /^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(value)
        || /^(?:data|blob):/i.test(value);
}

function needsRewrite(value) {
    return value.includes('/images/countries/')
        || value.includes('theoresundbridge.com/seeders/flags');
}

function flagFileName(value, code) {
    const raw = String(value || '').trim();
    if (raw) {
        const clean = raw.split(/[?#]/, 1)[0];
        const parts = clean.split('/').filter(Boolean);
        const fileName = parts[parts.length - 1] || '';
        if (fileName) {
            return fileName.toLowerCase();
        }
    }

    const normalizedCode = String(code || '').trim().toLowerCase();
    return normalizedCode ? `${normalizedCode}.svg` : '';
}

function buildCdnUrl(fileName) {
    return `${REMOTE_FLAG_BASE_URL}/${encodeURIComponent(String(fileName).toLowerCase())}`;
}

/**
 * The API can return bare flag filenames, broken project URLs under
 * /images/countries/, or legacy theoresundbridge CDN paths. Normalize them to
 * the shared admin flag CDN (lowercase filenames).
 */
export function resolveFlagUrl(value, code = '') {
    const raw = String(value || '').trim();
    if (!raw && !code) return '';

    if (needsRewrite(raw) || !isExternalUrl(raw)) {
        const fileName = flagFileName(raw, code);
        return fileName ? buildCdnUrl(fileName) : '';
    }

    if (raw.startsWith('/img/')) return raw;

    return raw;
}

export function normalizeFlagEntity(entity) {
    if (!entity || typeof entity !== 'object') return entity;
    return {
        ...entity,
        flag: resolveFlagUrl(entity.flag, entity.code)
    };
}
